import { useState, readonly, useEventListener, onMounted } from '#imports'

export const useCookiebotConsent = () => {
    const isConsentReady = useState<boolean>('cookiebot:is-consent-ready', () => false)

    const onConsentReady = () => {
        isConsentReady.value = true
    }

    if (import.meta.client) {
        useEventListener(window, 'CookiebotOnConsentReady', onConsentReady)

        if (window.Cookiebot?.hasResponse) {
            isConsentReady.value = true
        }

        // useEventListener registers the actual addEventListener via flush: "post",
        // which defers it until after the component render cycle. If Cookiebot fires
        // CookiebotOnConsentReady during that window, the event is missed.
        // onMounted runs after flush: "post", so by this point the listener is
        // registered. Re-check here to catch events that fired during hydration.
        onMounted(() => {
            if (!isConsentReady.value && window.Cookiebot?.hasResponse) {
                isConsentReady.value = true
            }
        })
    }

    return {
        isConsentReady: readonly(isConsentReady)
    }
}
